import Grid from '@mui/material/Grid';
import { CircularSkeleton, RoundedSkeleton } from '../../Common/Skeleton';

function LoadingCalendarOption() {
  return (
    <Grid
      p="16px 24px"
      borderRadius="10px"
      display="flex"
      flexDirection="row"
      width="100%"
      justifyContent="space-between"
      alignItems="center"
    >
      <Grid display="flex" alignItems="center" gap={3}>
        <CircularSkeleton width={32} height={32} variant="circular" />
        <Grid display="flex" flexDirection="column" gap="12px">
          <RoundedSkeleton width={108} height={14.875} variant="rounded" />
          <RoundedSkeleton width={304} height={14.875} variant="rounded" />
        </Grid>
      </Grid>
      <RoundedSkeleton width={108} height={14.875} variant="rounded" />
    </Grid>
  );
}

export default LoadingCalendarOption;
